import gql from 'graphql-tag';

/**
 * Query to fetch a single inspection template by id (same shape as list query for mapper reuse).
 */
export const getInspectionTemplateQuery = gql`
  query getInspectionTemplate(
    $id: UUID!
    $channelId: UUID!
    $version: Int
  ) {
    inspectionTemplate(id: $id, channelId: $channelId, version: $version) {
      id
      schemaVersion
      version
      parentTemplateId
      locked
      parentTemplateLockedVersion
      metadata {
        name
        description
        templateType
        assetTypes
        tags
        buildingId {
          sourceEntityId
          sourceEntityType
          sourceType
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
      config {
        requirePhotoOnDeficiency
        maxPhotosPerItem
        requireNoteOnDeficiency
        defaultQuestionType
        allowObservationItems
        completionRules {
          allItemsRequired
          allowPartialSubmission
        }
      }
      sections {
        id
        name
        description
        order
        origin
        config {
          requirePhotoOnDeficiency
          skippable
          collapsedByDefault
        }
        items {
          id
          label
          helpText
          order
          origin
          questionType
          questionConfig
          required
          photosEnabled
          notesEnabled
          config {
            requirePhotoOnDeficiency
            requireNoteOnDeficiency
            minPhotos
            isComplianceItem
            tags
            category
          }
        }
      }
    }
  }
`;
